import {Component, OnInit} from '@angular/core';

import {select} from '@angular-redux/store';
import {ActionsService} from "../../../Redux/Actions/actions.service";
import {ApplicationSpecActions} from "../../../Redux/Actions/application-spec-actions";
import {IInput, IOutput} from "../../../models/ISpec";
import {IBounds, IEntityAlert, IKeyValuePair} from "../../../models/common";
import {ADD_OUTPUT, REMOVE_OUTPUT} from "../../../models/view";
import {Observable} from "rxjs";
import {Router} from "@angular/router";


@Component({
  selector: 'test-specification-view',
  templateUrl: './specification-view.component.html',
  styleUrls: ['./specification-view.component.css']
})
export class TestSpecificationViewComponent implements OnInit {

  @select(['appSpec', 'spec', 'value', 'input']) inputVal$: Observable<IInput<number>>;
  @select(['appSpec', 'spec', 'note', 'input']) inputNote$: Observable<IInput<IEntityAlert>>;

  @select(['appSpec', 'spec', 'value', 'output']) outputVal$: Observable<IOutput<number>>;
  @select(['appSpec', 'spec', 'note', 'output']) outputNote$: Observable<IOutput<IEntityAlert>>;

  @select(['appSpec', 'noteGlobal']) noteGlobal$;

  constructor(private act: ActionsService, private router: Router) {
  }

  ngOnInit() {
    // redirect to error page
    this.router.navigate(['/error']);
  }

  getOutputsBound(): IBounds {
    return {min: 1, max: 1};
  }

  setVinRange(vinRange: IInput<number>) {
//    console.log("VIN RANGE");
    this.act.sendAction(ApplicationSpecActions.setInputLimits(vinRange));
  }

  onChangeOutput(event: IOutput<number>) {
    // console.log("Change output", event)
    this.act.sendAction(ApplicationSpecActions.setOutputValue(event));
  }

  onResizeOutput(event: IKeyValuePair) {
    // console.log("Resize output", event)
    if (event.key === ADD_OUTPUT.key) {
      this.act.sendAction(ApplicationSpecActions.addOutput());
    } else if (event.key === REMOVE_OUTPUT.key) {
      this.act.sendAction(ApplicationSpecActions.removeOutput(event.value));
    }
  }


  // this function is not used
  setSingleOutput(idx: number, volt: number, current: number) {
    this.act.sendAction(ApplicationSpecActions.setSingleOutput(idx, {voltage: volt, current: current}));
  }

}
